
import CardCarousel from './casrouselCard';
import { Tools } from '../../../../../utils/discover-features';

const AdministrativeTools = () => {
  return (
    <section className="pt-0 pb-lg-8 pb-2">
      <div className="container">
        <CardCarousel Tools={Tools} />
      </div>
    </section>);
};

export { AdministrativeTools };
